import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { NetworkTagsComponent } from '@app/features/merakis/modules/network-tags/pages/network-tags.component';
import { MerakiNetworkCardComponent } from '@app/features/merakis/components/network-card/network-card.component';


@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        NetworkTagsComponent,
        MerakiNetworkCardComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class NetworkTagsModule {}